import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';

import { RoleWithPermissionsResponse } from '@/api/roles/types';
import { report } from '@/shared/security/permissions/report';

export const editModalConfig = (orgs: any, allRoles: RoleWithPermissionsResponse[]) =>
  [
    {
      label: 'Фамилия',
      key: 'lastName',
      type: 'text',
      validation: [Validators.required()],
    },
    {
      label: 'Имя',
      key: 'firstName',
      type: 'text',
      validation: [Validators.required()],
    },
    {
      label: 'Отчество',
      key: 'middleName',
      type: 'text',
    },
    {
      label: 'Организация',
      key: 'organizationId',
      type: 'cascader',
      validation: [Validators.required()],
      payload: {
        options: orgs,
        fieldNames: {
          label: 'shortName',
          value: 'id',
          children: 'children',
        },
      },
    },
    {
      label: 'Роль',
      key: 'roleNames',
      type: 'select',
      payload: {
        options: allRoles,
        mode: 'multiple',
        fieldNames: {
          label: 'description',
          value: 'name',
        },
      },
    },
    {
      label: 'Должность',
      key: 'position',
      type: 'text',
      validation: [Validators.required()],
    },
    {
      label: 'E-mail',
      key: 'email',
      type: 'text',
      validation: [Validators.required()],
      disabled: true,
    },
    {
      label: 'Номер телефона',
      key: 'phone',
      type: 'text',
    },
    {
      label: 'Отправлять ежедневную сводку',
      key: 'sendStatusMail',
      type: 'radioGroup',
      hidden: (form) => {
        const hide =
          form.getFieldValue('organizationId')?.length > 3 ||
          !form
            .getFieldValue('roleNames')
            ?.some((roleName: string) =>
              allRoles?.some(
                (role) =>
                  role.name === roleName &&
                  role.permissions?.some(
                    (permission) => permission.name === report.receiveStatusMail,
                  ),
              ),
            );
        if (hide) form.setFieldValue('sendStatusMail', false);
        return hide;
      },
      payload: {
        direction: 'horizontal',
        options: [
          { value: true, label: 'Да' },
          { value: false, label: 'Нет' },
        ],
      },
    },
  ] as IFormItem[];
